import { ReactElement } from 'react'
import { Link, Tooltip } from '@mui/material'

export type Results2HeaderRelationLinkProps = {
  label: string
  tooltip: string
  onClick: () => void
}

const Results2HeaderRelationLink = ({
  label,
  tooltip,
  onClick,
}: Results2HeaderRelationLinkProps): ReactElement => (
  <Tooltip title={tooltip} arrow disableInteractive>
    <Link
      component="button"
      type="button"
      underline="hover"
      onClick={onClick}
      sx={{
        fontFamily: 'Roboto',
        fontSize: 12,
        fontWeight: 500,
        lineHeight: 1.2,
        p: 0,
        minHeight: 0,
        height: 'auto',
        border: 0,
        bgcolor: 'transparent',
        cursor: 'pointer',
        flexShrink: 0,
        display: 'inline-flex',
        alignItems: 'center',
      }}
    >
      {label}
    </Link>
  </Tooltip>
)

export default Results2HeaderRelationLink
